import { createAsyncThunk } from "@reduxjs/toolkit";
import { BaseResponse } from "api/models/infrastructure";
import { JobsCriteria, JobsResponse, ReprocessJobRequest } from "api/models/queues";
import { queuesService } from "api/services";

export const jobsActions = {
    getJobs: "jobs/get",
    reprocessJob: "job/reprocess"
};

export const getJobs = createAsyncThunk(
    jobsActions.getJobs,
    async (criteria: JobsCriteria) => {
        return await queuesService.getJobs(criteria) || {} as JobsResponse;
    }
);

export const reprocessJob = createAsyncThunk(
    jobsActions.reprocessJob,
    async (request: ReprocessJobRequest) => {
        return await queuesService.reprocessJob(request) || {} as BaseResponse;
    }
);

